import ClienteService from '@/src/services/clientes'
import PlanoService from '@/src/services/planos'
import InternacaoService from '@src/services/internacao'
import { carnetGenerate, planValueCalc, vencimentoMensalidade } from '@utils/plan'
import Carnet from '@/src/services/carnet'
import RegrasInternacaoService from '@/src/services/regrasInternacao'
import PagamentoService from '@/src/services/pagamento'

const clienteMixin = {
  data() {
    return {
      depositosFields: [
        {
          key: 'data',
          label: "Data",
          field: "data"
        },
        {
          key: 'valor',
          label: "Valor",
          field: "valor"
        },
        {
          key: 'caixa',
          label: 'Caixa',
          field: 'caixa'
        }
      ],
      clientesFields: [
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
          field: 'nome',
        },
        {
          key: 'email',
          label: 'Email',
          class: 'size-col-20',
          field: 'email',
        },
        {
          key: 'plano.descricao',
          label: 'Plano',
          class: 'size-col-20',
          field: 'plano',
        },
        {
          key: 'cpf',
          label: 'CPF',
          class: 'size-col-20',
          field: 'cpf',
        },
        {
          key: 'cartao',
          label: 'Cartão',
          class: 'size-col-20',
          field: 'cartao',
        },
        {
          field: 'identidade',
          label: 'Identidade',
        },
        {
          field: 'nascimento',
          label: 'nascimento',
        },
        {
          field: 'sexo',
          label: 'Sexo',
        },
        {
          field: 'endereco',
          label: 'Endereço',
        },
        {
          field: 'bairro',
          label: 'Bairro',
        },
        {
          field: 'cidade',
          label: 'Cidade',
        },
        {
          field: 'estado',
          label: 'Estado',
        },
        {
          field: 'CEP',
          label: 'CEP',
        },
        {
          field: 'cadastro',
          label: 'Cadastro',
        },
        {
          field: 'renovacao',
          label: 'Renovação',
        },
        {
          field: 'vencimento',
          label: 'Vencimento',
        },

        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      dependentesFields: [
        {
          key: 'dependente',
          label: 'Dependente',
        },
        {
          key: 'cartao',
          label: 'Cartão',
        },
        {
          key: 'cpf',
          label: 'CPF',
        },
        {
          key: 'internacao',
          label: 'Internação',
        },
        {
          key: 'dataNascimento',
          label: 'Data de Nascimento',
        },
        { key: 'actions', label: '' },
      ],
      dependentes: [],
      regrasInternacao: [],
    }
  },
  methods: {
    async loadRegrasInternacao() {
      const { data } = await RegrasInternacaoService.list()
      this.regrasInternacao = data
      this.regrasInternacao.unshift({
        _id: null,
        descricao: "Nenhum"
      })
  },
    async exportCustomersWhoDeclareIncomeTax() {
      const { data } = await ClienteService.exportCustomersWhoDeclareIncomeTax()

      return data
    },
    findOnePlan(id){
      return PlanoService.findOne(id)
    },
    habilitarInternacao(id){
      return ClienteService.habilitarInternacao(id)
    },
    loadClientes(page=null, limit=null, filter=null, tipoPesquisa=null) {
      return ClienteService.list(page, limit, filter, tipoPesquisa)
        .then((response) => response)
        .catch((error) => error)
    },
    loadClientesBySelect(){
      return ClienteService
        .listBySelect()
        .then(response => response.data)
        .catch(error => error)
    },
    loadClientesBySelectByText(text){
      return ClienteService
        .listBySelectByText(text)
        .then(response => response.data)
        .catch(error => error)
    },
    registerCliente(cliente) {
      return ClienteService.create(cliente)
    },
    findOneCliente(id){
      return ClienteService.findOne(id)
    },
    async deleteCliente(id) {
      await ClienteService.remove(id)
    },
    async editCliente(id, cliente) {
      return await ClienteService.update(id, cliente)
    },
    async uploadImage(image){
      return await ClienteService.uploadImage(image)
    },
    async carnetGenerate(cliente) {
      const carnet = carnetGenerate(1, cliente)

      await Carnet.create({
        plano: cliente.plano?cliente.plano._id?cliente.plano._id:cliente.plano:null,
        cliente: cliente._id,
        vencimento: carnet[carnet.length-1].vencimento,
        cadastroCliente: cliente.cadastro,
        cartao: cliente.cartao,
        valor: carnet[carnet.length-1].valorParcela,
        parcelas: 12
      })

      cliente.vencimento = carnet[carnet.length - 1].vencimento
      await ClienteService.update(id, cliente)
    },
    async devolucao(cliente, valor) {
      return await PagamentoService.withdrawBalance(cliente, valor)
    },
  },
}

export default clienteMixin
